"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importStar(require("../Themes/styled-components"));
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var Loader_1 = tslib_1.__importDefault(require("../Loader"));
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  border-top-width: 0;\n  user-select: none;\n"], ["\n  display: flex;\n  border-top-width: 0;\n  user-select: none;\n"])));
var IconWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  color: ", ";\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: ", " solid ", ";\n  :not(:last-child) {\n    border-right-width: 0;\n  }\n  &:first-child {\n    border-radius: ", " 0 0 ", ";\n  }\n  &:nth-child(3) {\n    min-width: ", ";\n  }\n  &:last-child {\n    border-radius: 0 ", " ", " 0;\n  }\n"], ["\n  position: relative;\n  padding: ", " ", ";\n  height: ", ";\n  font-size: ", ";\n  color: ", ";\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: ", " solid ", ";\n  :not(:last-child) {\n    border-right-width: 0;\n  }\n  &:first-child {\n    border-radius: ", " 0 0 ", ";\n  }\n  &:nth-child(3) {\n    min-width: ", ";\n  }\n  &:last-child {\n    border-radius: 0 ", " ", " 0;\n  }\n"])), polished_1.rem(10), polished_1.rem(20), polished_1.rem(40), polished_1.rem(12), function (_a) {
    var theme = _a.theme;
    return theme.paginator.textColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.paginator.backgroundColor;
}, polished_1.rem(1), function (_a) {
    var theme = _a.theme;
    return theme.paginator.borderColor;
}, polished_1.rem(5), polished_1.rem(5), polished_1.rem(70), polished_1.rem(5), polished_1.rem(5));
var Button = styled_components_1.default(IconWrapper)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  padding: ", ";\n  cursor: ", ";\n  ", "\n"], ["\n  padding: ", ";\n  cursor: ", ";\n  ",
    "\n"])), polished_1.rem(10), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    if (!disabled) {
        return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n        :hover {\n          background: ", ";\n        }\n      "], ["\n        :hover {\n          background: ", ";\n        }\n      "])), theme.paginator.hoverBackgroundColor);
    }
    return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject([""], [""])));
});
var LoaderWrapper = styled_components_1.default('div')(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: translate(-50%, -50%);\n"], ["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: translate(-50%, -50%);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.paginator.backgroundColor;
});
exports.default = styled_components_1.withTheme(React.memo(function (_a) {
    var loading = _a.loading, offset = _a.offset, limit = _a.limit, total = _a.total, onChangeOffset = _a.onChangeOffset, theme = _a.theme;
    var page = total === 0 ? 0 : Math.ceil((offset + 1) / limit);
    var totalPages = Math.ceil(total / limit);
    var isAtTheBeggining = page === 1;
    var isAtTheEnd = page >= totalPages;
    return (React.createElement(Wrapper, null,
        React.createElement(Button, { disabled: isAtTheBeggining, onClick: function () {
                if (!isAtTheBeggining) {
                    onChangeOffset(0);
                }
            }, "data-testid": "Paginator-Arrow-left-to-end" },
            React.createElement(Icon_1.default, { name: "arrow-left-to-end", color: isAtTheBeggining
                    ? theme.paginator.disabledColor
                    : theme.paginator.activeColor })),
        React.createElement(Button, { disabled: isAtTheBeggining, onClick: function () {
                if (!isAtTheBeggining) {
                    onChangeOffset(offset - limit > 0 ? offset - limit : 0);
                }
            }, "data-testid": "Paginator-arrow-left" },
            React.createElement(Icon_1.default, { name: "arrow-left", color: isAtTheBeggining
                    ? theme.paginator.disabledColor
                    : theme.paginator.activeColor })),
        React.createElement(IconWrapper, { "data-testid": "Paginator-Counter" },
            loading && (React.createElement(LoaderWrapper, null,
                React.createElement(Loader_1.default, { color: theme.paginator.activeColor }))),
            page,
            " z ",
            totalPages),
        React.createElement(Button, { disabled: isAtTheEnd, onClick: function () {
                if (!isAtTheEnd) {
                    onChangeOffset(page * limit);
                }
            }, "data-testid": "Paginator-arrow-right" },
            React.createElement(Icon_1.default, { name: "arrow-right", color: isAtTheEnd
                    ? theme.paginator.disabledColor
                    : theme.paginator.activeColor })),
        React.createElement(Button, { disabled: isAtTheEnd, onClick: function () {
                if (!isAtTheEnd) {
                    onChangeOffset((totalPages - 1) * limit);
                }
            }, "data-testid": "Paginator-arrow-right-to-end" },
            React.createElement(Icon_1.default, { name: "arrow-right-to-end", color: isAtTheEnd
                    ? theme.paginator.disabledColor
                    : theme.paginator.activeColor }))));
}));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
